import { ArrowLeft } from 'lucide-react'

/**
 * CircleBackButton — reusable circular back-navigation icon button.
 * Matches the soft-neutral pill/circle style used across admin pages:
 * - 40 × 40 px circle, no border, neutral-50 background
 * - Left-arrow icon centred, no text label
 * - Subtle hover darkens the background; focus ring for a11y
 */
export function CircleBackButton({
  onClick,
  ariaLabel = 'Go back',
}: {
  onClick: () => void
  ariaLabel?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-neutral-50 text-neutral-500 transition hover:bg-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  )
}
